// source: pbtypes/sim/simulator/disturbances.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.simulator.DisturbanceRequest', null, global);
goog.exportSymbol('proto.simulator.DisturbanceRequest.DisturbanceType', null, global);
goog.exportSymbol('proto.simulator.DisturbanceRequest.NormalDistributionCase', null, global);
goog.exportSymbol('proto.simulator.DisturbanceRequest.RandomWalkCase', null, global);
goog.exportSymbol('proto.simulator.DisturbanceRequest.VonKarmanCase', null, global);
goog.exportSymbol('proto.simulator.PeriodicDisturbance', null, global);
goog.exportSymbol('proto.simulator.RandomWalk', null, global);
goog.exportSymbol('proto.simulator.RandomWalkBound', null, global);
goog.exportSymbol('proto.simulator.RandomWalkComponent', null, global);
goog.exportSymbol('proto.simulator.RandomWalkWind', null, global);
goog.exportSymbol('proto.simulator.VonKarmanWind', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.PeriodicDisturbance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.simulator.PeriodicDisturbance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.PeriodicDisturbance.displayName = 'proto.simulator.PeriodicDisturbance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.RandomWalkComponent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.simulator.RandomWalkComponent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.RandomWalkComponent.displayName = 'proto.simulator.RandomWalkComponent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.RandomWalkBound = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.simulator.RandomWalkBound, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.RandomWalkBound.displayName = 'proto.simulator.RandomWalkBound';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.RandomWalk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.simulator.RandomWalk.repeatedFields_, null);
};
goog.inherits(proto.simulator.RandomWalk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.RandomWalk.displayName = 'proto.simulator.RandomWalk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.RandomWalkWind = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.simulator.RandomWalkWind, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.RandomWalkWind.displayName = 'proto.simulator.RandomWalkWind';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.VonKarmanWind = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.simulator.VonKarmanWind, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.VonKarmanWind.displayName = 'proto.simulator.VonKarmanWind';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.simulator.DisturbanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.simulator.DisturbanceRequest.repeatedFields_, proto.simulator.DisturbanceRequest.oneofGroups_);
};
goog.inherits(proto.simulator.DisturbanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.simulator.DisturbanceRequest.displayName = 'proto.simulator.DisturbanceRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.PeriodicDisturbance.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.PeriodicDisturbance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.PeriodicDisturbance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.PeriodicDisturbance.toObject = function(includeInstance, msg) {
  var f, obj = {
amplitude: (f = msg.getAmplitude()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
period: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
phaseOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.PeriodicDisturbance}
 */
proto.simulator.PeriodicDisturbance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.PeriodicDisturbance;
  return proto.simulator.PeriodicDisturbance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.PeriodicDisturbance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.PeriodicDisturbance}
 */
proto.simulator.PeriodicDisturbance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setAmplitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPeriod(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhaseOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.PeriodicDisturbance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.PeriodicDisturbance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.PeriodicDisturbance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.PeriodicDisturbance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmplitude();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPhaseOffset();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional eigen_lcm.Vector3dPb amplitude = 1;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.simulator.PeriodicDisturbance.prototype.getAmplitude = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 1));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.simulator.PeriodicDisturbance} returns this
*/
proto.simulator.PeriodicDisturbance.prototype.setAmplitude = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.PeriodicDisturbance} returns this
 */
proto.simulator.PeriodicDisturbance.prototype.clearAmplitude = function() {
  return this.setAmplitude(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.PeriodicDisturbance.prototype.hasAmplitude = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float period = 2;
 * @return {number}
 */
proto.simulator.PeriodicDisturbance.prototype.getPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.PeriodicDisturbance} returns this
 */
proto.simulator.PeriodicDisturbance.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float phase_offset = 3;
 * @return {number}
 */
proto.simulator.PeriodicDisturbance.prototype.getPhaseOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.PeriodicDisturbance} returns this
 */
proto.simulator.PeriodicDisturbance.prototype.setPhaseOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.RandomWalkComponent.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.RandomWalkComponent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.RandomWalkComponent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkComponent.toObject = function(includeInstance, msg) {
  var f, obj = {
magnitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
timeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.RandomWalkComponent}
 */
proto.simulator.RandomWalkComponent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.RandomWalkComponent;
  return proto.simulator.RandomWalkComponent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.RandomWalkComponent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.RandomWalkComponent}
 */
proto.simulator.RandomWalkComponent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMagnitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTimeConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.RandomWalkComponent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.RandomWalkComponent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.RandomWalkComponent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkComponent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMagnitude();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getTimeConstant();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional float magnitude = 1;
 * @return {number}
 */
proto.simulator.RandomWalkComponent.prototype.getMagnitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalkComponent} returns this
 */
proto.simulator.RandomWalkComponent.prototype.setMagnitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float time_constant = 2;
 * @return {number}
 */
proto.simulator.RandomWalkComponent.prototype.getTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalkComponent} returns this
 */
proto.simulator.RandomWalkComponent.prototype.setTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.RandomWalkBound.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.RandomWalkBound.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.RandomWalkBound} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkBound.toObject = function(includeInstance, msg) {
  var f, obj = {
start: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
end: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.RandomWalkBound}
 */
proto.simulator.RandomWalkBound.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.RandomWalkBound;
  return proto.simulator.RandomWalkBound.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.RandomWalkBound} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.RandomWalkBound}
 */
proto.simulator.RandomWalkBound.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.RandomWalkBound.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.RandomWalkBound.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.RandomWalkBound} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkBound.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional float start = 1;
 * @return {number}
 */
proto.simulator.RandomWalkBound.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalkBound} returns this
 */
proto.simulator.RandomWalkBound.prototype.setStart = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float end = 2;
 * @return {number}
 */
proto.simulator.RandomWalkBound.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalkBound} returns this
 */
proto.simulator.RandomWalkBound.prototype.setEnd = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.simulator.RandomWalk.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.RandomWalk.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.RandomWalk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.RandomWalk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalk.toObject = function(includeInstance, msg) {
  var f, obj = {
componentsList: jspb.Message.toObjectList(msg.getComponentsList(),
    proto.simulator.RandomWalkComponent.toObject, includeInstance),
boundsList: jspb.Message.toObjectList(msg.getBoundsList(),
    proto.simulator.RandomWalkBound.toObject, includeInstance),
mean: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
noiseDt: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.RandomWalk}
 */
proto.simulator.RandomWalk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.RandomWalk;
  return proto.simulator.RandomWalk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.RandomWalk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.RandomWalk}
 */
proto.simulator.RandomWalk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.simulator.RandomWalkComponent;
      reader.readMessage(value,proto.simulator.RandomWalkComponent.deserializeBinaryFromReader);
      msg.addComponents(value);
      break;
    case 2:
      var value = new proto.simulator.RandomWalkBound;
      reader.readMessage(value,proto.simulator.RandomWalkBound.deserializeBinaryFromReader);
      msg.addBounds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMean(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setNoiseDt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.RandomWalk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.RandomWalk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.RandomWalk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComponentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.simulator.RandomWalkComponent.serializeBinaryToWriter
    );
  }
  f = message.getBoundsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.simulator.RandomWalkBound.serializeBinaryToWriter
    );
  }
  f = message.getMean();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getNoiseDt();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * repeated RandomWalkComponent components = 1;
 * @return {!Array<!proto.simulator.RandomWalkComponent>}
 */
proto.simulator.RandomWalk.prototype.getComponentsList = function() {
  return /** @type{!Array<!proto.simulator.RandomWalkComponent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.simulator.RandomWalkComponent, 1));
};


/**
 * @param {!Array<!proto.simulator.RandomWalkComponent>} value
 * @return {!proto.simulator.RandomWalk} returns this
*/
proto.simulator.RandomWalk.prototype.setComponentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.simulator.RandomWalkComponent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.simulator.RandomWalkComponent}
 */
proto.simulator.RandomWalk.prototype.addComponents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.simulator.RandomWalkComponent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.simulator.RandomWalk} returns this
 */
proto.simulator.RandomWalk.prototype.clearComponentsList = function() {
  return this.setComponentsList([]);
};


/**
 * repeated RandomWalkBound bounds = 2;
 * @return {!Array<!proto.simulator.RandomWalkBound>}
 */
proto.simulator.RandomWalk.prototype.getBoundsList = function() {
  return /** @type{!Array<!proto.simulator.RandomWalkBound>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.simulator.RandomWalkBound, 2));
};


/**
 * @param {!Array<!proto.simulator.RandomWalkBound>} value
 * @return {!proto.simulator.RandomWalk} returns this
*/
proto.simulator.RandomWalk.prototype.setBoundsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.simulator.RandomWalkBound=} opt_value
 * @param {number=} opt_index
 * @return {!proto.simulator.RandomWalkBound}
 */
proto.simulator.RandomWalk.prototype.addBounds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.simulator.RandomWalkBound, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.simulator.RandomWalk} returns this
 */
proto.simulator.RandomWalk.prototype.clearBoundsList = function() {
  return this.setBoundsList([]);
};


/**
 * optional float mean = 3;
 * @return {number}
 */
proto.simulator.RandomWalk.prototype.getMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalk} returns this
 */
proto.simulator.RandomWalk.prototype.setMean = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float noise_dt = 4;
 * @return {number}
 */
proto.simulator.RandomWalk.prototype.getNoiseDt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.RandomWalk} returns this
 */
proto.simulator.RandomWalk.prototype.setNoiseDt = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.RandomWalkWind.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.RandomWalkWind.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.RandomWalkWind} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkWind.toObject = function(includeInstance, msg) {
  var f, obj = {
xyMagnitude: (f = msg.getXyMagnitude()) && proto.simulator.RandomWalk.toObject(includeInstance, f),
xyAngle: (f = msg.getXyAngle()) && proto.simulator.RandomWalk.toObject(includeInstance, f),
z: (f = msg.getZ()) && proto.simulator.RandomWalk.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.RandomWalkWind}
 */
proto.simulator.RandomWalkWind.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.RandomWalkWind;
  return proto.simulator.RandomWalkWind.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.RandomWalkWind} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.RandomWalkWind}
 */
proto.simulator.RandomWalkWind.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.simulator.RandomWalk;
      reader.readMessage(value,proto.simulator.RandomWalk.deserializeBinaryFromReader);
      msg.setXyMagnitude(value);
      break;
    case 2:
      var value = new proto.simulator.RandomWalk;
      reader.readMessage(value,proto.simulator.RandomWalk.deserializeBinaryFromReader);
      msg.setXyAngle(value);
      break;
    case 3:
      var value = new proto.simulator.RandomWalk;
      reader.readMessage(value,proto.simulator.RandomWalk.deserializeBinaryFromReader);
      msg.setZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.RandomWalkWind.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.RandomWalkWind.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.RandomWalkWind} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.RandomWalkWind.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXyMagnitude();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.simulator.RandomWalk.serializeBinaryToWriter
    );
  }
  f = message.getXyAngle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.simulator.RandomWalk.serializeBinaryToWriter
    );
  }
  f = message.getZ();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.simulator.RandomWalk.serializeBinaryToWriter
    );
  }
};


/**
 * optional RandomWalk xy_magnitude = 1;
 * @return {?proto.simulator.RandomWalk}
 */
proto.simulator.RandomWalkWind.prototype.getXyMagnitude = function() {
  return /** @type{?proto.simulator.RandomWalk} */ (
    jspb.Message.getWrapperField(this, proto.simulator.RandomWalk, 1));
};


/**
 * @param {?proto.simulator.RandomWalk|undefined} value
 * @return {!proto.simulator.RandomWalkWind} returns this
*/
proto.simulator.RandomWalkWind.prototype.setXyMagnitude = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.RandomWalkWind} returns this
 */
proto.simulator.RandomWalkWind.prototype.clearXyMagnitude = function() {
  return this.setXyMagnitude(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.RandomWalkWind.prototype.hasXyMagnitude = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RandomWalk xy_angle = 2;
 * @return {?proto.simulator.RandomWalk}
 */
proto.simulator.RandomWalkWind.prototype.getXyAngle = function() {
  return /** @type{?proto.simulator.RandomWalk} */ (
    jspb.Message.getWrapperField(this, proto.simulator.RandomWalk, 2));
};


/**
 * @param {?proto.simulator.RandomWalk|undefined} value
 * @return {!proto.simulator.RandomWalkWind} returns this
*/
proto.simulator.RandomWalkWind.prototype.setXyAngle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.RandomWalkWind} returns this
 */
proto.simulator.RandomWalkWind.prototype.clearXyAngle = function() {
  return this.setXyAngle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.RandomWalkWind.prototype.hasXyAngle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RandomWalk z = 3;
 * @return {?proto.simulator.RandomWalk}
 */
proto.simulator.RandomWalkWind.prototype.getZ = function() {
  return /** @type{?proto.simulator.RandomWalk} */ (
    jspb.Message.getWrapperField(this, proto.simulator.RandomWalk, 3));
};


/**
 * @param {?proto.simulator.RandomWalk|undefined} value
 * @return {!proto.simulator.RandomWalkWind} returns this
*/
proto.simulator.RandomWalkWind.prototype.setZ = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.RandomWalkWind} returns this
 */
proto.simulator.RandomWalkWind.prototype.clearZ = function() {
  return this.setZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.RandomWalkWind.prototype.hasZ = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.VonKarmanWind.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.VonKarmanWind.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.VonKarmanWind} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.VonKarmanWind.toObject = function(includeInstance, msg) {
  var f, obj = {
amplitude: (f = msg.getAmplitude()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
freeStreamAirSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
heightAboveGround: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.VonKarmanWind}
 */
proto.simulator.VonKarmanWind.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.VonKarmanWind;
  return proto.simulator.VonKarmanWind.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.VonKarmanWind} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.VonKarmanWind}
 */
proto.simulator.VonKarmanWind.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setAmplitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFreeStreamAirSpeed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeightAboveGround(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.VonKarmanWind.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.VonKarmanWind.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.VonKarmanWind} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.VonKarmanWind.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmplitude();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getFreeStreamAirSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getHeightAboveGround();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional eigen_lcm.Vector3dPb amplitude = 1;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.simulator.VonKarmanWind.prototype.getAmplitude = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 1));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.simulator.VonKarmanWind} returns this
*/
proto.simulator.VonKarmanWind.prototype.setAmplitude = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.VonKarmanWind} returns this
 */
proto.simulator.VonKarmanWind.prototype.clearAmplitude = function() {
  return this.setAmplitude(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.VonKarmanWind.prototype.hasAmplitude = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float free_stream_air_speed = 2;
 * @return {number}
 */
proto.simulator.VonKarmanWind.prototype.getFreeStreamAirSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.VonKarmanWind} returns this
 */
proto.simulator.VonKarmanWind.prototype.setFreeStreamAirSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float height_above_ground = 3;
 * @return {number}
 */
proto.simulator.VonKarmanWind.prototype.getHeightAboveGround = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.VonKarmanWind} returns this
 */
proto.simulator.VonKarmanWind.prototype.setHeightAboveGround = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.simulator.DisturbanceRequest.repeatedFields_ = [4,5];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.simulator.DisturbanceRequest.oneofGroups_ = [[6],[7],[8]];

/**
 * @enum {number}
 */
proto.simulator.DisturbanceRequest.NormalDistributionCase = {
  NORMAL_DISTRIBUTION_NOT_SET: 0,
  NORMAL_DISTRIBUTION_STDEV: 6
};

/**
 * @return {proto.simulator.DisturbanceRequest.NormalDistributionCase}
 */
proto.simulator.DisturbanceRequest.prototype.getNormalDistributionCase = function() {
  return /** @type {proto.simulator.DisturbanceRequest.NormalDistributionCase} */(jspb.Message.computeOneofCase(this, proto.simulator.DisturbanceRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.simulator.DisturbanceRequest.RandomWalkCase = {
  RANDOM_WALK_NOT_SET: 0,
  RANDOM_WALK_WIND: 7
};

/**
 * @return {proto.simulator.DisturbanceRequest.RandomWalkCase}
 */
proto.simulator.DisturbanceRequest.prototype.getRandomWalkCase = function() {
  return /** @type {proto.simulator.DisturbanceRequest.RandomWalkCase} */(jspb.Message.computeOneofCase(this, proto.simulator.DisturbanceRequest.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.simulator.DisturbanceRequest.VonKarmanCase = {
  VON_KARMAN_NOT_SET: 0,
  VON_KARMAN_WIND: 8
};

/**
 * @return {proto.simulator.DisturbanceRequest.VonKarmanCase}
 */
proto.simulator.DisturbanceRequest.prototype.getVonKarmanCase = function() {
  return /** @type {proto.simulator.DisturbanceRequest.VonKarmanCase} */(jspb.Message.computeOneofCase(this, proto.simulator.DisturbanceRequest.oneofGroups_[2]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.simulator.DisturbanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.simulator.DisturbanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.simulator.DisturbanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.DisturbanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
constant: (f = msg.getConstant()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
squareWavesList: jspb.Message.toObjectList(msg.getSquareWavesList(),
    proto.simulator.PeriodicDisturbance.toObject, includeInstance),
sineWavesList: jspb.Message.toObjectList(msg.getSineWavesList(),
    proto.simulator.PeriodicDisturbance.toObject, includeInstance),
normalDistributionStdev: (f = msg.getNormalDistributionStdev()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
randomWalkWind: (f = msg.getRandomWalkWind()) && proto.simulator.RandomWalkWind.toObject(includeInstance, f),
vonKarmanWind: (f = msg.getVonKarmanWind()) && proto.simulator.VonKarmanWind.toObject(includeInstance, f),
windFieldCsvPath: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.simulator.DisturbanceRequest}
 */
proto.simulator.DisturbanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.simulator.DisturbanceRequest;
  return proto.simulator.DisturbanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.simulator.DisturbanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.simulator.DisturbanceRequest}
 */
proto.simulator.DisturbanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.simulator.DisturbanceRequest.DisturbanceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 4:
      var value = new proto.simulator.PeriodicDisturbance;
      reader.readMessage(value,proto.simulator.PeriodicDisturbance.deserializeBinaryFromReader);
      msg.addSquareWaves(value);
      break;
    case 5:
      var value = new proto.simulator.PeriodicDisturbance;
      reader.readMessage(value,proto.simulator.PeriodicDisturbance.deserializeBinaryFromReader);
      msg.addSineWaves(value);
      break;
    case 6:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setNormalDistributionStdev(value);
      break;
    case 7:
      var value = new proto.simulator.RandomWalkWind;
      reader.readMessage(value,proto.simulator.RandomWalkWind.deserializeBinaryFromReader);
      msg.setRandomWalkWind(value);
      break;
    case 8:
      var value = new proto.simulator.VonKarmanWind;
      reader.readMessage(value,proto.simulator.VonKarmanWind.deserializeBinaryFromReader);
      msg.setVonKarmanWind(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWindFieldCsvPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.simulator.DisturbanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.simulator.DisturbanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.simulator.DisturbanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.simulator.DisturbanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getSquareWavesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.simulator.PeriodicDisturbance.serializeBinaryToWriter
    );
  }
  f = message.getSineWavesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.simulator.PeriodicDisturbance.serializeBinaryToWriter
    );
  }
  f = message.getNormalDistributionStdev();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getRandomWalkWind();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.simulator.RandomWalkWind.serializeBinaryToWriter
    );
  }
  f = message.getVonKarmanWind();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.simulator.VonKarmanWind.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.simulator.DisturbanceRequest.DisturbanceType = {
  UNKNOWN: 0,
  WIND_DISTURBANCE: 1,
  FORCE_DISTURBANCE: 2,
  TORQUE_DISTURBANCE: 3,
  CLEAR_DISTURBANCES: 4
};

/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.simulator.DisturbanceRequest.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional DisturbanceType type = 2;
 * @return {!proto.simulator.DisturbanceRequest.DisturbanceType}
 */
proto.simulator.DisturbanceRequest.prototype.getType = function() {
  return /** @type {!proto.simulator.DisturbanceRequest.DisturbanceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.simulator.DisturbanceRequest.DisturbanceType} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional eigen_lcm.Vector3dPb constant = 3;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.simulator.DisturbanceRequest.prototype.getConstant = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setConstant = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.DisturbanceRequest.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated PeriodicDisturbance square_waves = 4;
 * @return {!Array<!proto.simulator.PeriodicDisturbance>}
 */
proto.simulator.DisturbanceRequest.prototype.getSquareWavesList = function() {
  return /** @type{!Array<!proto.simulator.PeriodicDisturbance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.simulator.PeriodicDisturbance, 4));
};


/**
 * @param {!Array<!proto.simulator.PeriodicDisturbance>} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setSquareWavesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.simulator.PeriodicDisturbance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.simulator.PeriodicDisturbance}
 */
proto.simulator.DisturbanceRequest.prototype.addSquareWaves = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.simulator.PeriodicDisturbance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearSquareWavesList = function() {
  return this.setSquareWavesList([]);
};


/**
 * repeated PeriodicDisturbance sine_waves = 5;
 * @return {!Array<!proto.simulator.PeriodicDisturbance>}
 */
proto.simulator.DisturbanceRequest.prototype.getSineWavesList = function() {
  return /** @type{!Array<!proto.simulator.PeriodicDisturbance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.simulator.PeriodicDisturbance, 5));
};


/**
 * @param {!Array<!proto.simulator.PeriodicDisturbance>} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setSineWavesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.simulator.PeriodicDisturbance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.simulator.PeriodicDisturbance}
 */
proto.simulator.DisturbanceRequest.prototype.addSineWaves = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.simulator.PeriodicDisturbance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearSineWavesList = function() {
  return this.setSineWavesList([]);
};


/**
 * optional eigen_lcm.Vector3dPb normal_distribution_stdev = 6;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.simulator.DisturbanceRequest.prototype.getNormalDistributionStdev = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 6));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setNormalDistributionStdev = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.simulator.DisturbanceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearNormalDistributionStdev = function() {
  return this.setNormalDistributionStdev(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.DisturbanceRequest.prototype.hasNormalDistributionStdev = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RandomWalkWind random_walk_wind = 7;
 * @return {?proto.simulator.RandomWalkWind}
 */
proto.simulator.DisturbanceRequest.prototype.getRandomWalkWind = function() {
  return /** @type{?proto.simulator.RandomWalkWind} */ (
    jspb.Message.getWrapperField(this, proto.simulator.RandomWalkWind, 7));
};


/**
 * @param {?proto.simulator.RandomWalkWind|undefined} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setRandomWalkWind = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.simulator.DisturbanceRequest.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearRandomWalkWind = function() {
  return this.setRandomWalkWind(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.DisturbanceRequest.prototype.hasRandomWalkWind = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional VonKarmanWind von_karman_wind = 8;
 * @return {?proto.simulator.VonKarmanWind}
 */
proto.simulator.DisturbanceRequest.prototype.getVonKarmanWind = function() {
  return /** @type{?proto.simulator.VonKarmanWind} */ (
    jspb.Message.getWrapperField(this, proto.simulator.VonKarmanWind, 8));
};


/**
 * @param {?proto.simulator.VonKarmanWind|undefined} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
*/
proto.simulator.DisturbanceRequest.prototype.setVonKarmanWind = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.simulator.DisturbanceRequest.oneofGroups_[2], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearVonKarmanWind = function() {
  return this.setVonKarmanWind(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.DisturbanceRequest.prototype.hasVonKarmanWind = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string wind_field_csv_path = 9;
 * @return {string}
 */
proto.simulator.DisturbanceRequest.prototype.getWindFieldCsvPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.setWindFieldCsvPath = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.simulator.DisturbanceRequest} returns this
 */
proto.simulator.DisturbanceRequest.prototype.clearWindFieldCsvPath = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.simulator.DisturbanceRequest.prototype.hasWindFieldCsvPath = function() {
  return jspb.Message.getField(this, 9) != null;
};


goog.object.extend(exports, proto.simulator);
